exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".steps-header > .step-count {\n  display: none;\n}\n.steps-header > .step-index::after {\n  content: \". \";\n}\n", ""]);

// exports
